import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import EstimateModal from './EstimateModal';

const EstimateModalContext = createContext();

export const useEstimateModal = () => {
  const context = useContext(EstimateModalContext);
  if (!context) {
    throw new Error('useEstimateModal must be used within EstimateModalProvider');
  }
  return context;
};

export const EstimateModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasAutoShown, setHasAutoShown] = useState(false);
  const location = useLocation();

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Auto-show modal after 4 seconds (only once per session)
  useEffect(() => {
    // Check if already shown in this session
    const alreadyShown = sessionStorage.getItem('estimateModalShown');
    
    if (alreadyShown || hasAutoShown) {
      return;
    }

    // Don't auto-show on routes that are conversion-flows / claim-flows of their own
    const noAutoShowRoutes = [
      '/get-estimate',
      '/supa-value-guarantee',
      '/supa-promise',
      '/heat-pump',
      '/referral-program',
      '/support',
      '/msb',
      '/game-on-climate-action',
    ];
    if (noAutoShowRoutes.some((p) => location.pathname.startsWith(p))) {
      return;
    }

    const timer = setTimeout(() => {
      setIsOpen(true);
      setHasAutoShown(true);
      sessionStorage.setItem('estimateModalShown', 'true');
    }, 4000);

    return () => clearTimeout(timer);
  }, [location.pathname, hasAutoShown]);

  return (
    <EstimateModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
      <EstimateModal open={isOpen} onOpenChange={setIsOpen} />
    </EstimateModalContext.Provider>
  );
};
